import { memo } from 'react'
import { Button, Result } from '@arco-design/web-react'
import { useNavigate } from 'react-router-dom'
import LogoHead from '../components/LogoHead'

const status_codes = {
  200: 'OK - 请求成功',
  201: 'Created - 请求已经被实现',
  204: 'No Content - 服务器成功处理了请求，但没有返回任何内容',
  400: 'Bad Request - 服务器无法理解请求',
  401: 'Unauthorized - 请求未授权',
  403: 'Forbidden - 服务器拒绝请求',
  404: 'Not Found - 请求的资源无法找到',
  500: 'Internal Server Error - 服务器遇到错误，无法完成请求',
  502: 'Bad Gateway - 服务器作为网关或代理，从上游服务器收到无效响应',
  503: 'Service Unavailable - 服务器当前无法处理请求',
  504: 'Gateway Timeout - 服务器作为网关或代理，未及时从上游服务器收到响应',
}
const StatusPage = memo(({ code }) => {
  const navigate = useNavigate()
  const status = !Object.hasOwn(status_codes, code)
    ? ''
    : status_codes[code]?.split(' - ')
  const msg = status[0]
  const desc = status[1]
  return <div className="p-4 w-full h-[80vh] bg-white">
    <LogoHead/>
    <div className="w-full h-full flex justify-center items-center">
      <Result
        status={code}
        title={<div>
          <span className="font-bold text-6xl">{code}</span>
          <span className="text-2xl font-bold">（{msg}）</span>
        </div>}
        subTitle={
          <div>

            <p className="text-3xl font-bold m-6">{desc}</p>
          </div>
        }
        extra={[
          <Button className="mr-4"
                  key="again"
                  onClick={e => window.location.reload()}>
            重试
          </Button>, <Button key="back"
                             type="primary"
                             onClick={e => {
                               navigate(-1)
                             }}
          >
            返回
          </Button>]}>
      </Result>
    </div>
  </div>
})

export default StatusPage
